"use client";
import classes from "./Sidebar.module.scss";
import { useState } from "react";
import Link from "next/link";
import ArrowWithTailWrapper from "./ArrowWithTailWrapper/ArrowWithTailWrapper";
import { useRouter } from "next/navigation";

interface sidebarProps {
  sideBarArr: any;
}

const Sidebar = ({ sideBarArr }: sidebarProps) => {
  const [sectionActive, setSectionActive] = useState<number>(-1);

  const router = useRouter();

  const dropdownEleClickHandler =
    (receivedIndex: number, id: string) => (e: React.MouseEvent) => {
      e.preventDefault(); // Prevent default anchor behavior
      setSectionActive(receivedIndex);

      const element = document.getElementById(id);
      if (element) {
        const offset = 200; // Center element
        window.scrollTo({
          top: element.offsetTop - offset,
          behavior: "smooth",
        });
      }
    };

  return (
    <div className={classes["sidebar-container"]}>
      <div
        className={classes["arrow-text-container"]}
        onClick={() => router.back()}
      >
        <ArrowWithTailWrapper />
        <p>All Posts / Latest News</p>
      </div>

      <div className={classes["sidebar-links-container"]}>
        {sideBarArr.map((el: any, index: number) => (
          <Link
            key={index}
            href={`#${el.id}`}
            className={
              sectionActive === index
                ? `${classes["sidebar-link"]} ${classes["sidebar-link-active"]}`
                : `${classes["sidebar-link"]}`
            }
            onClick={dropdownEleClickHandler(index, el.id)}
          >
            {el.header}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
